import React, { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { get } from 'lodash-es';
import { useDispatch, useSelector } from 'react-redux';
import { animatedThumbnailsSelector } from './selectors';
import { loadAnimatedThumbnailDataAction } from './actions';
import { useThumbnailStyle } from './use-thumbnail-style';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlayCircle } from '@fortawesome/pro-duotone-svg-icons';

export const VideoItemGeneratedThumbnail = ({ videoId, isHovered, url, children, thumbnailUrl }) => {
  const thumbnailRef = useRef();
  const dispatch = useDispatch();

  const animatedThumbnail = get(useSelector(animatedThumbnailsSelector), videoId);

  useEffect(() => {
    if (isHovered && !animatedThumbnail) {
      dispatch(loadAnimatedThumbnailDataAction(videoId));
    }
  }, [videoId, isHovered, dispatch, animatedThumbnail]);

  const [thumbnailStyle, isAnimationTimedOut] = useThumbnailStyle({
    isHovered,
    videoId,
    element: thumbnailRef.current,
    thumbnailUrl,
  });

  return (
    <Link to={url} data-e2e="ct-video-generated__placeholder" className="ct-video-generated__placeholder">
      <div className="ct-video-item__thumbnail" ref={thumbnailRef} style={thumbnailStyle}>
        {isHovered && isAnimationTimedOut && (
          <FontAwesomeIcon
            className="ct-playbutton-mask"
            color="white"
            style={{ '--fa-secondary-color': 'black' }}
            icon={faPlayCircle}
            size="4x"
          />
        )}
        {children}
      </div>
    </Link>
  );
};
